if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id], [name*="[id]"]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.updateButton = this.querySelector('button[name="personalisation-update"]');
        this.querySelectorAll('button').forEach(button => { button.addEventListener('click', (e) => this.handleErrorMessage()) })
        if (this.updateButton) {
          this.updateButton.addEventListener('click', this.onUpdateHandler.bind(this));
        }

        if (document.querySelector('cart-drawer')) {
          if (this.submitButton) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }

          if (this.updateButton) {
            this.updateButton.setAttribute('aria-haspopup', 'dialog');
          }
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onUpdateHandler(evt) {

        if (this.updateButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.updateButton.setAttribute('aria-disabled', true);
        this.updateButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const firstInput = this.querySelector('[id*="PersonalisationFirstLine-"]');
        const secondInput = this.querySelector('[id*="PersonalisationSecondLine-"]');
        const cartChangeData = {
          id: this.updateButton.dataset.key,
          properties : {
            'First line': firstInput.value.toUpperCase(),
            'Second line': secondInput.value.toUpperCase(),
            "_group_id": this.updateButton.dataset.groupId
          },
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }

        fetch(`${routes.cart_change_url}`, {
          ...fetchConfig(),
          body: JSON.stringify(cartChangeData)
        })
        .then((response) => {
          return response.text();
        })
        .then((state) => {

          const parsedState = JSON.parse(state);
          if (parsedState.errors) {
            console.log('parsedState.errors', parsedState.errors);
            return;
          }
  
          const cartBubble = document.querySelector('#cart-icon-bubble');
          const stickyNavSwitchedButton = document.querySelector('.sticky-nav__element--show');
  
          if (stickyNavSwitchedButton && parsedState.item_count === 0 && !window.location.pathname.includes('/products/') && !window.location.pathname.includes('/collections/')) {
            stickyNavSwitchedButton.classList.remove('hidden');
            cartBubble.classList.add('sticky-nav__element--hide');
          }
  
          this.cart.renderContents(parsedState);

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: undefined });

          const prevSibling = evt.target.previousElementSibling;

          if (prevSibling && prevSibling.id.includes('ModalClose')) {
            prevSibling.click();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.updateButton.classList.remove('loading');
          this.updateButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      canProceedAdd() {
        if (this.dataset.productName.includes("eto wine decanter") && window.cartStrings?.decanters_error != "") {
          let counter = 0;
          this.cart.querySelectorAll(".cart-item").forEach(item => {
            if (item.dataset.productName.includes("eto wine decanter") && item.dataset.qty) counter += item.dataset.qty * 1;
          })
          if (counter >= 3) {
            this.handleErrorMessage(window.cartStrings.decanters_error);
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return false;
          }
        }
        return true;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (!this.canProceedAdd()) return;

        const currentTime = Date.now();

        if (formData.has("items[1][properties][First line]")) {
          formData.set("items[1][properties][First line]", `${formData.get("items[1][properties][First line]").toUpperCase()}`)
        }

        if (formData.has("items[1][properties][Second line]")) {
          formData.set("items[1][properties][Second line]", `${formData.get("items[1][properties][Second line]").toUpperCase()}`)
        }

        if (formData.has("items[0][properties][_group_id]")) {
          formData.set("items[0][properties][_group_id]", `${currentTime}`)
        }

        if (formData.has("items[1][properties][_group_id]")) {
          formData.set("items[1][properties][_group_id]", `${currentTime}`)
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const prevSibling = evt.submitter.previousElementSibling;

              if (prevSibling && prevSibling.id.includes('ModalClose')) {
                prevSibling.click();
              }

              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.innerHTML = errorMessage;
        }
      }
    }
  );
}
